import React, { FC } from 'react';
import CloseButton from '@components/closeButton';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';
import { SimpleOnPress } from '@interfaces/base';

export interface CloseButtonWrapperProps extends Partial<SimpleOnPress> {
  testID?: string;
}

const CloseButtonWrapper: FC<CloseButtonWrapperProps> = ({ onPress, testID }) => {
  const { C, scale, onDefaultClose } = useOperatorPanelSettingsWrapperContext();

  return <CloseButton C={C} onPress={onPress ?? onDefaultClose} scale={scale} testID={testID} />;
};

export default CloseButtonWrapper;
